var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 4.16675H6.66536C3.4437 4.16675 0.832031 6.77842 0.832031 10.0001C0.832031 13.2217 3.4437 15.8334 6.66536 15.8334H13.332C16.5537 15.8334 19.1654 13.2217 19.1654 10.0001C19.1654 6.77842 16.5537 4.16675 13.332 4.16675Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 12.5C14.7127 12.5 15.832 11.3807 15.832 10C15.832 8.61929 14.7127 7.5 13.332 7.5C11.9513 7.5 10.832 8.61929 10.832 10C10.832 11.3807 11.9513 12.5 13.332 12.5Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetup);
export default __webpack_public_path__ + "static/media/setup.f88e276956c27a7728adec3ae214011a.svg";
export { ForwardRef as ReactComponent };